import * as React from 'react'
import { CompressOutlined, DeleteOutlined } from '@ant-design/icons'
import { Button, Col, List, Row, Modal } from 'antd'
import { RouteComponentProps, withRouter } from 'react-router'
import moment from 'moment'

import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import container from '../../wires/Bootstrapper'
import { IStresstestService } from '../../services/StresstestService'

import { TTAvatar } from '../shared/TTAvatar'
import { StressTestListModel } from '../../models/StressTestModels'

interface StresstestListProps {
    clienteId?: string
}

class StresstestListState extends StressTestListModel {

}

class StresstestListComp extends React.Component<RouteComponentProps & StresstestListProps, StresstestListState> {

    service: IStresstestService

    constructor(props) {
        super(props)
        this.state = new StresstestListState()
        this.service = container.get(SERVICE_IDENTIFIER.STRESSTEST_SERVICE)
    }

    componentDidMount() {
        this.loadList()
    }

    loadList = async () => {
        let data = await this.service.GetStressTestList(this.props.clienteId)
        if (data.IsValid == true)
            this.setState(data)
    }

    onTestClick = id => {
        this.props.history.push(`Dettaglio/${id}`)
    }

    onDelete = (itemId: string) => {
        Modal.confirm({
            title: "Elimina",
            content: "Eliminare questo stress test?",
            onOk: async () => {
                let resp = await this.service.Delete(itemId)
                if (resp.IsValid == true)
                    this.loadList()
            }
        })
    }

    render() {
        return (
            <List dataSource={this.state.Lista}
                rowKey={it => it.Id}
                renderItem={item => (
                    <List.Item key={item.Id}>
                        <List.Item.Meta
                            avatar={<TTAvatar icon={<CompressOutlined />} />}
                            title={<a onClick={() => this.onTestClick(item.Id)}>{moment(item.Periodo).format("MMMM").toUpperCase()}</a>}
                            description={<Row>
                                <Col span={5}>{moment(item.Periodo).format("YYYY")}</Col>
                                <Col span={5}><b>{item.NomeStressTest}</b></Col>
                                <Col span={5}>con incasso: <b>{moment(item.MeseIncasso).format("MMMM YYYY")}</b></Col>
                                <Col span={5}>senza incasso: <b>{moment(item.MeseZeroIncasso).format("MMMM YYYY")}</b></Col>
                                <Col span={4}>{this.state.IsUser ? <Button type="primary" key="delete-stress-test" icon={<DeleteOutlined />} size="small" onClick={() => this.onDelete(item.Id)} /> : <></>}</Col>
                            </Row> }
                        />
                        
                    </List.Item>
                )} />
        )
    }
}

export const StresstestList = withRouter(StresstestListComp)